import React from 'react';


const UngroupIcon = ({className = '', muted = false}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className}>
      <g clipPath="url(#clip0_591_3241)">
        <path d="M13.3578 0.662109C13.3578 2.53086 13.3578 4.33868 13.3578 6.20743C10.6968 6.20743 8.07656 6.20743 5.375 6.20743C5.375 4.37931 5.375 2.55117 5.375 0.662109C8.01562 0.662109 10.6359 0.662109 13.3578 0.662109ZM7 2.24649C7 3.11993 7 3.87146 7 4.60271C8.64531 4.60271 10.2095 4.60271 11.7532 4.60271C11.7532 3.7699 11.7532 3.01837 11.7532 2.24649C10.1079 2.24649 8.58438 2.24649 7 2.24649Z" fill={muted ? '#00000042' : '#32324D'} />
        <path d="M8.5032 7.99512C8.5032 9.86387 8.5032 11.6311 8.5032 13.4998C5.84227 13.4998 3.20156 13.4998 0.5 13.4998C0.5 11.692 0.5 9.88418 0.5 7.99512C3.12031 7.99512 5.76102 7.99512 8.5032 7.99512ZM6.89844 9.59983C5.2125 9.59983 3.64844 9.59983 2.125 9.59983C2.125 10.4326 2.125 11.1842 2.125 11.8952C3.77031 11.8952 5.33437 11.8952 6.89844 11.8952C6.89844 11.0827 6.89844 10.3514 6.89844 9.59983Z" fill={muted ? '#00000042' : '#32324D'} />
      </g>
      <defs>
        <clipPath id="clip0_591_3241">
          <rect width="13" height="13" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UngroupIcon;
